export default "__VITE_ASSET__DKfPYE9E__"